import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppointmentComponent } from './appointment.component';
import { ActionCenterComponent } from './action-center/action-center.component';

const routes: Routes = [
  {
    path: '',
    component: AppointmentComponent,
    children: [
      { path: '', redirectTo: 'appointments', pathMatch: 'full' },
      { path: 'appointments', component: AppointmentComponent },
      { path: 'manageevents', component: AppointmentComponent },      
      { path: 'administration', component: AppointmentComponent },
      { path: 'actioncenter', component: AppointmentComponent },
      { path: 'reports/appt-detail-report', component: AppointmentComponent },
      { path: 'reports/trend-view', component: AppointmentComponent },
      { path: 'reports/campaigns-view', component: AppointmentComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppointmentRoutingModule { }
